export default __webpack_public_path__ + "static/media/android_step2.d0955106.jpg";